// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","slidesWrapper":"App_slidesWrapper__V9b1W","slide":"App_slide__1owCH"};